/**
 * VersionBadge
 *
 * Displays a colored badge for taxonomy/prompt version status.
 */

import React from 'react';

type VersionStatus = 'draft' | 'live' | 'archived';

const STATUS_STYLES: Record<VersionStatus, string> = {
  live: 'bg-green-100 text-green-700',
  draft: 'bg-amber-100 text-amber-700',
  archived: 'bg-gray-100 text-gray-600',
};

const STATUS_DOTS: Record<VersionStatus, string> = {
  live: 'bg-green-500',
  draft: 'bg-amber-500',
  archived: 'bg-gray-400',
};

interface VersionBadgeProps {
  status: VersionStatus;
  showDot?: boolean;
  className?: string;
}

const VersionBadge: React.FC<VersionBadgeProps> = ({
  status,
  showDot = true,
  className = '',
}) => {
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full ${STATUS_STYLES[status]} ${className}`}
    >
      {showDot && (
        <span className={`w-1.5 h-1.5 rounded-full ${STATUS_DOTS[status]}`} />
      )}
      {status}
    </span>
  );
};

export default VersionBadge;
